/**
 * API de organización usando Axios.
 */
import { axiosInstance } from "features/shared/api";
import type { OrganizationDto } from "common/models";

export const organizationApi = {
    get: (address: string) =>
        axiosInstance.get<OrganizationDto>(`/api/organization/${address}`),
};
